import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import {
  inquiryByIdSelector,
  artisanPrivateInquiriesIsLoadingSelector,
  proposalById,
} from '../../../../../modules/myInquiries/Artisan/Private/Selectors';
import {
  getMyArtisanPrivateInquiryAction,
  addProposalByArtisanAction,
  getMyArtisanProposalAction,
  editProposalByArtisanAction,
} from '../../../../../modules/myInquiries/Artisan/Private/Actions';
import { getArtisanProductsAction } from '../../../../../modules/artisanProducts/Actions';
import {
  artisansProductsAsLabelAndValueSelector,
  artisanProductByIdSelector,
} from '../../../../../modules/artisanProducts/Selectors';

import {
  InputField,
  TextArea,
  Select,
  FormSectionTitle,
  Upload,
} from '../../../../../components/form';

import FormGroup from '../../../../../components/form/FormGroup';
import { artisanDataSelector } from '../../../../../modules/auth/Selectors';
import getLangData from '../../../../../utils/getLangData';

const ViewPrivateInquiry = (props) => {
  const {
    isLoading,
    pendingIsLoading,
    inquiryID,
    addProposal,
    // inquiry,
    editProposal,
    proposal,
    getProposal,
    getPrivateInquiry,
    getArtisanProducts,
    artisanData,
  } = props;

  // for testing only
  const artisanId = artisanData._id;
  const { trusted } = artisanData
  const lang = getLangData().fields
  useEffect(() => {
    getArtisanProducts();
    getProposal(inquiryID);
    console.log(proposal);
  }, [inquiryID, getPrivateInquiry]);

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...proposal }}
      onSubmit={(values) => {
        const body = {
          price: values.proposal.price,
          message: values.proposal.message,
          customerId: values.customerId,
          inquiryId: values._id,
          artisanId: values.artisanId,
          attachment: values.proposal.attachment,
        };
        editProposal(body, trusted);
      }}
    >
      {({ values, handleSubmit, setFieldValue }) => {
        return (
          <FormGroup
            handleSubmit={handleSubmit}
            heading={lang.view_private_inquiry}
            isLoading={isLoading || pendingIsLoading}
          >
            <InputField
              name="customerProfileDetail.businessName"
              label={lang.customer_name}
              disabled
            />
            <InputField name="artisanProduct.name" label={lang.product} disabled />
            <TextArea name="message" label={lang.message} disabled />
            <InputField name="qtyRequired" label={lang.quantity_required} disabled />
            <Upload
              disabled={true}
              data={{ userID: artisanId }}
              name="attachment"
              label={`${lang.inquiry_image} :`}
              S3Bucket="warshatna-users"
              // API="customer/customer-category-image-signedurl/"
              API="users/user-profile-image-signedurl"
            />
            <FormSectionTitle>{lang.my_proposal}</FormSectionTitle>
            <InputField name="proposal.price" label={lang.price} type="number" />
            <TextArea name="proposal.message" label={lang.my_message} />
            <Upload
              data={{ userID: artisanId }}
              name="proposal.attachment"
              label={`${lang.inquiry_image} :`}
              S3Bucket="warshatna-users"
              // API="customer/customer-category-image-signedurl/"
              API="users/user-profile-image-signedurl"
            />
          </FormGroup>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    proposal: proposalById(state, inquiryID),
    isLoading: artisanPrivateInquiriesIsLoadingSelector(state),

    // artisanProducts: artisansProductsAsLabelAndValueSelector(state),
    artisanSingleProduct: artisanProductByIdSelector(state, props.id),
    artisanData: artisanDataSelector(state),
  };
};

const mapDispatchToProps = {
  getProposal: getMyArtisanProposalAction,
  // addProposal: addProposalByArtisanAction,
  editProposal: editProposalByArtisanAction,
  getArtisanProducts: getArtisanProductsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPrivateInquiry);
